import { render, staticRenderFns } from "./videos.vue?vue&type=template&id=708355c5&"
import script from "./videos.vue?vue&type=script&lang=ts&"
export * from "./videos.vue?vue&type=script&lang=ts&"
import style0 from "./videos.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports